import { supabase } from '@/lib/supabase';
import type { SpecRevisionRow } from '@/types/database';

export async function listRevisions(specId: string): Promise<SpecRevisionRow[]> {
  const { data, error } = await supabase
    .from('spec_revisions')
    .select('*')
    .eq('spec_id', specId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}
